(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Vue"), require("VueRouter"));
	else if(typeof define === 'function' && define.amd)
		define(["Vue", "VueRouter"], factory);
	else if(typeof exports === 'object')
		exports["QchartsReact"] = factory(require("Vue"), require("VueRouter"));
	else
		root["QchartsReact"] = factory(root["Vue"], root["VueRouter"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__15__) {
return 